import { get } from 'lodash-es';

export default {
  getCompaniesMetric: (state) => (companyId, type) => get(state, ['companiesMetricData', type, companyId]),
  unifiedMetricData: ({ unifiedMetricData }) => unifiedMetricData,
};
